import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;
`;

export const Header = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    color: #333;
    margin: 0;
  }
`;

export const FormContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

export const FormSection = styled.div`
  padding: 24px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  h2 {
    font-size: 1.25rem;
    color: #333;
    margin: 0 0 24px 0;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  &.three-columns {
    grid-template-columns: repeat(3, 1fr);

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
`;

export const InputGroup = styled.div`
  &.full-width {
    grid-column: 1 / -1;
  }

  label {
    display: block;
    font-size: 0.875rem;
    color: #666;
    margin-bottom: 8px;
  }

  input, select, textarea {
    width: 100%;
    padding: 12px;
    border: 2px solid #eee;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #34574A;
      outline: none;
    }
  }

  textarea {
    min-height: 120px;
    resize: vertical;
  }
`;

export const ImageUpload = styled.div`
  border: 2px dashed #eee;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #34574A;
  }

  .icon {
    font-size: 2rem;
    color: #666;
    margin-bottom: 8px;
  }

  .text {
    font-size: 0.875rem;
    color: #666;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 24px;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &.primary {
    background: #34574A;
    color: white;
    border: none;

    &:hover {
      background: #2a4539;
    }
  }

  &.secondary {
    background: white;
    border: 2px solid #eee;
    color: #666;

    &:hover {
      background: #f8f9fa;
    }
  }
`;